import { GoogleMapsEnvironment } from '@qaroni-merchant-env/environment';

export const GoogleMapsEnv = {
  key: Object.prototype.hasOwnProperty.call(GoogleMapsEnvironment, 'key')
    ? GoogleMapsEnvironment.key
    : null,
};
